export default {
  NoAction: '',
  Accepted: 'P',
  Added: 'A', // For ORM
  New: 'N', // For PNET
  Changed: 'C',
  Deleted: 'D',
  AcknowledgedDelete: 'K'
}
